import { finiteMetric } from "./performingAssetsMetrics";

const summaryItem = ({ t, label, translationKey, value }) => {
  const numeric = finiteMetric(value);
  if (!label || numeric === null || !translationKey) return null;
  return { label, value: t(translationKey, { value: numeric }) };
};

export const buildPerformingAssetSummary = ({
  t,
  statistics,
  impressionsLabel,
  ctrLabel,
  clicksLabel,
  resultsLabel,
  valueNumber,
  valuePercentage,
  roasLabel,
}) => {
  if (!statistics) return [];

  const items = [
    summaryItem({
      t,
      label: impressionsLabel,
      translationKey: valueNumber,
      value: statistics.impressions,
    }),
    summaryItem({
      t,
      label: ctrLabel,
      translationKey: valuePercentage,
      value: statistics.ctr,
    }),
    summaryItem({
      t,
      label: clicksLabel,
      translationKey: valueNumber,
      value: statistics.click,
    }),
    summaryItem({
      t,
      label: resultsLabel,
      translationKey: valueNumber,
      value: statistics.mainAction,
    }),
  ].filter(Boolean);

  const roas = finiteMetric(statistics.roas);
  if (roasLabel && roas !== null && roas > 0) {
    items.push({
      label: roasLabel,
      value: t(valueNumber, { value: roas }),
    });
  }

  return items;
};
